import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter--checkmark",
  "use": "icon-filter--checkmark-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"icon-filter--checkmark\"><path d=\"M12 1.22 3.427 9.918 0 6.44l.618-.607.619-.61 2.188 2.22L10.763 0 12 1.22Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol